// removed by extract-text-webpack-plugin
module.exports = {"container":"container__22Zvm","cardDetails":"cardDetails__1jhSF","label":"label__3AJLu","value":"value__1j8X1"};


//////////////////
// WEBPACK FOOTER
// ./components/tableCards/style.scss
// module id = Ge/D
// module chunks = 22